import { atom, selector } from 'recoil'
import { keyFactory } from 'src/utils/recoil'
import { CustomFootfall, CustomFootfallRequest, DAY_OF_WEEK_HOUR_ID, DayOfWeekHourTrends } from 'src/common-services'
import { getQuartersFromDates } from 'src/common-services/utils/date-quarters'
import { CustomFootFallDateRange } from 'src/atoms/custom-polygon'

import * as customPolygonAtoms from 'src/atoms/custom-polygon'
import * as mobilityAtoms from 'src/atoms/mobility'

const key = keyFactory('custom-polygon-hourly-foot-traffic')

export const dateRangeOptions = selector({
  key: key('date-range-options'),
  get: ({ get }) => {
    const validDateRange = get(mobilityAtoms.validDateRange)
    return getQuartersFromDates(validDateRange.start, validDateRange.end).reverse()
  },
})
// 3 months ago - present
export const LAST_QUARTER = selector({
  key: key('last-quarter'),
  get: ({ get }) => {
    const _dateRangeOptions = get(dateRangeOptions)
    return {
      start: _dateRangeOptions[0].start,
      end: _dateRangeOptions[0].end,
    }
  },
})

export const dateRange = atom<CustomFootFallDateRange>({
  key: key('date-range'),
  default: LAST_QUARTER,
})

export const request = selector<CustomFootfallRequest | undefined>({
  key: key('request'),
  get: ({ get }) => {
    const polygonId = get(customPolygonAtoms.polygonId)
    const polygonName = get(customPolygonAtoms.polygonName)

    const multipolygon = get(customPolygonAtoms.multipolygon)
    const { start, end } = get(dateRange)

    if (!polygonId || !polygonName || !multipolygon) {
      return undefined
    }

    const request: CustomFootfallRequest = {
      id: polygonId,
      name: polygonName,
      polygon: multipolygon,
      dataset: DAY_OF_WEEK_HOUR_ID,
      startDate: start,
      endDate: end,
    }
    return request
  },
})

export const loading = atom<boolean>({
  key: key('loading'),
  default: false,
})

export const error = atom<string | undefined>({
  key: key('error'),
  default: undefined,
})

export const response = atom<CustomFootfall<DayOfWeekHourTrends> | undefined>({
  key: key('response'),
  default: undefined,
})

export const reportId = selector<string | undefined>({
  key: key('report-id'),
  get: ({ get }) => {
    const resp = get(response)
    return resp?.reportId
  },
})

export const hourlyFootTraffic = selector<CustomFootfall<DayOfWeekHourTrends>['data']>({
  key: key('hourly-foot-traffic'),
  get: ({ get }) => {
    const resp = get(response)
    if (!resp || resp.status !== 'finished' || !resp.data) {
      return []
    }
    if (resp.data.length === 0) {
      return []
    }

    return resp.data
  },
})
